export { default } from 'shared/components/chip'
